// Constants for waterfall chart gradient configuration
export const GRADIENT_CONFIG = {
  NEGATIVE_COLOR: '#E16A83',
  POSITIVE_COLOR: '#64d1a6',
  DEFAULT_COLOR: '#60759C',
  OPACITY_DECREMENT: 0.07,
  BORDER_COLOR: 'rgba(255, 255, 255, 0.8)',
  BORDER_WIDTH: 0.002,
} as const;

// Chart styling constants
export const CHART_STYLES = {
  CHART_HEIGHT: '500px',
  AXIS_FONT_SIZE: '14px',
  LABEL_FONT_SIZE: '13px',
  LINE_WIDTH: 3,
} as const;

// Tooltip styling constants
export const TOOLTIP_STYLES = {
  PADDING: '12px',
  BORDER_RADIUS: '8px',
  BOX_SHADOW: '0 4px 12px rgba(0,0,0,0.15)',
  MIN_WIDTH: '280px',
  MAX_WIDTH: '400px',
  TITLE_COLOR: '#2c3e50',
  TEXT_COLOR: '#34495e',
  POSITIVE_VALUE_COLOR: '#27ae60',
  NEGATIVE_VALUE_COLOR: '#e74c3c',
  BORDER_COLOR: '#3498db',
} as const;